import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import { ToastService } from 'src/app/core/toast.service';
import { gql } from 'apollo-angular';
import { getjobposts, getAllJobs, getApplicantsinfos, getAllEmployeeTypeList, getAppliedDatas, getApplicantsJobDatas, addApplicantMessageMutation, getApplicantMessagemutation, deleteMessageMutation, editApplicantMessageMutations, getEnquiryListMutation, getAllEnquiry, getEnquiryMessagemutation, getAllJobsfiltered, talentPostservice, getAllTalentsHire, updateTalentHireApproveStatusMutation, getTalentMessagemutation, addTalentMessageMutation, deleteTalentMessageMutation, editTalentMessageMutation, getTalentEnquiryListMutation, getAllTalentEnquiryMutation, getAllTAlentEnquiryListMutation, getTalentEnquiryMessagemutation, getAllRequestMutation, getMonthlyJobsCountQuery, getJobListMutation, getAllTalentEnquiryPaginationQuery, getEnquiryCountOnlyQuery, getRequestCountOnlyQuery, getFilteredTalentList, getTalentAdminCountByStatus, getHiringFilterOptions, getHiringTalentCountByStatus, getHiringTalentList, getUniqueTalentFilterOptions, updateTalentStatusMutation, getAdminJobsTabCounts, getUserJobsTabCounts, getFilteredJobs, getJobCompanyName, getJobRoleName, getEmpTypeName, getFilterStatus, getJobListMutationByid, getRelatedJobs, updateHiringStatusMutation, getMyJobData, getJobFilteredEnquiry, getFilteredApplicants, getApplicantsMessage, TestgetApplicantsMessage, getApplicantsEnquiry, getApplicantTabcount, getMyappliedJobData, getMyEnquiryJobData, getMyEnquiryTalentData, getTalentsMessage, getTalentsEnquiry, getAllEnquiryTalentData, getAllTalentsRequest, getJobDetailsPreviewQuery } from '../queries/jobs.query';
import { getAllJobsRoleList, getAllJobsRoleMain } from '../../dashboard/modules/my-directory/queries/basicInfoTab.query';
import { LoginService } from 'src/app/core/services/login.service';


@Injectable()
export class PostnewJob {
  constructor(
    private apollo: Apollo,
    private toast: ToastService,
    private loginService: LoginService
  ) { }

  // async postNewJob(postjobObj: any): Promise<any> {
  //   try {
  //     await this.apollo
  //       .mutate({
  //         mutation: jobPostservice,
  //         variables: { postjobObj },
  //       })
  //       .pipe(pluck('data', 'insert_jobpost'))
  //       .toPromise();
  //     this.toast.openSnackBar('Added successfully');
  //     return true;
  //   } catch (err) {
  //     this.toast.openSnackBar('You Failed To add');
  //     return false;
  //   }
  // }

  //Getting All Employees
  getJobsList(limit: any, offset: any): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getjobposts,
        variables: { limit, offset },
      })
      .pipe(pluck('data', 'jobs'));
  }

  //Getting All Jobs with Applicent Count
  getAllJobs(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAllJobs,
      })
      .pipe(pluck('data', 'jobs'));
  }

  // get single job by id 
  getFilterJobsByid(
    id: string
  ): Observable<any[]> {
    return this.apollo.use("external").query({
      query: getJobListMutationByid,
      variables: { id }
    }).pipe(pluck('data', 'jobs'));
  }

  // getting preview
  gettingJobDetailsPreview(id: string | number): Observable<any[]> {
    return this.apollo
      .use('external')
      .query({
        query: getJobDetailsPreviewQuery,
        variables: { id }
      })
      .pipe(pluck('data', 'jobs'));
  }

  // getRelatedJobs by j_role
  getRelatedJobs(jRole: string, limit: number, offset: number, excludeId?: string): Observable<any> {
    return this.apollo.use("external").query({
      query: getRelatedJobs,
      variables: { jRole, limit, offset, excludeId },
      fetchPolicy: 'network-only',
    }).pipe(pluck('data', 'jobs'));
  }


  getMonthlyJobsCount(andList): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getMonthlyJobsCountQuery,
        variables: { andList },
      })
      .pipe(pluck('data', 'jobs_aggregate', 'aggregate', 'count'));
  }

  //Getting All Employees
  getApplicantsInfo(job_id): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getApplicantsinfos,
        variables: {
          job_id: job_id,
        },
      })
      .pipe(pluck('data', 'job_applicants'));
  }

  // deleteJobPost(job_id: string): Promise<any> {
  //   return this.apollo
  //     .mutate({
  //       mutation: deleteJobFromListMutation,
  //       variables: {
  //         id: job_id,
  //       },
  //     })
  //     .toPromise();
  // }

  // async updateJob(jobId: string, postjobObj: any): Promise<any> {
  //   try {
  //     await this.apollo
  //       .mutate({
  //         mutation: updateJobMutation,
  //         variables: {
  //           id: jobId,
  //           postjobObj: postjobObj,
  //         },
  //       })
  //       .pipe(pluck('data', 'update_jobpost'))
  //       .toPromise();
  //     this.toast.openSnackBar('Updated successfully');
  //     return true;
  //   } catch (err) {
  //     console.error('Update Error:', err);
  //     this.toast.openSnackBar('Failed to update');
  //     return false;
  //   }
  // }

  // updateActiveStatus(jobId: string, status: string): Observable<any> {
  //   return this.apollo.mutate({
  //     mutation: updateJobStatusMutation,
  //     variables: {
  //       id: jobId,
  //       status: status,
  //     },
  //   });
  // }

  // updateJobStatus(jobId: string, status: string): Observable<any> {
  //   return this.apollo.mutate({
  //     mutation: updateJobApproveStatusMutation,
  //     variables: {
  //       id: jobId,
  //       status: status,
  //     },
  //   });
  // }

  // job role
  // addRoles(role: any): Promise<any> {
  //   return this.apollo
  //     .mutate({
  //       mutation: addRoleMutation,
  //       variables: {
  //         object: role,
  //       },
  //     })
  //     .toPromise();
  // }

  getJobsRoleList(): Observable<any> {
    return this.apollo
      .subscribe({
        query: getAllJobsRoleList,
      })
      .pipe(pluck('data', 'jobs_role_list'));
  }


  getJobsRoleMain(): Observable<any> {
    return this.apollo
      .subscribe({
        query: getAllJobsRoleMain,
      })
      .pipe(pluck('data', 'jobs_role_list'));
  }



  // deleteRoles(roleId: string): Promise<any> {
  //   return this.apollo
  //     .mutate({
  //       mutation: deleteRolesMutation,
  //       variables: {
  //         id: roleId,
  //       },
  //     })
  //     .toPromise();
  // }

  // editJobRole(roleId: string, roleName: string): Promise<any> {
  //   return this.apollo
  //     .mutate({
  //       mutation: editJobsRoleMutation,
  //       variables: {
  //         id: roleId,
  //         roleName: roleName,
  //       },
  //     })
  //     .toPromise();
  // }

  // job employee Type
  // addEmployeeType(employeetype: any): Promise<any> {
  //   return this.apollo
  //     .mutate({
  //       mutation: addEmployeeTypeMutation,
  //       variables: {
  //         object: employeetype,
  //       },
  //     })
  //     .toPromise();
  // }

  getEmployeeTypeList(): Observable<any> {
    return this.apollo
      .subscribe({
        query: getAllEmployeeTypeList,
      })
      .pipe(pluck('data', 'job_types'));
  }

  // deleteEmployeeType(EmployeeTypeId: string): Promise<any> {
  //   return this.apollo
  //     .mutate({
  //       mutation: deleteEmployeeTypeMutation,
  //       variables: {
  //         id: EmployeeTypeId,
  //       },
  //     })
  //     .toPromise();
  // }

  // editEmployeeType(
  //   employeeTypeId: string,
  //   employeeTypeName: string
  // ): Promise<any> {
  //   return this.apollo
  //     .mutate({
  //       mutation: editEmployeeTypeMutation,
  //       variables: {
  //         id: employeeTypeId,
  //         employeeTypeName: employeeTypeName,
  //       },
  //     })
  //     .toPromise();
  // }

  // updateJobApplicantStatus(jobId: string, status: string): Observable<any> {
  //   return this.apollo.mutate({
  //     mutation: updateJobApplicantStatusMutation,
  //     variables: {
  //       id: jobId,
  //       status: status,
  //     },
  //   });
  // }

  // Get applied data
  // getAppliedData(dental_professional_id): Observable<any> {
  //   return this.apollo.use("external").subscribe({
  //     query: getAppliedDatas,
  //     variables: {
  //       "dental_professional_id": dental_professional_id
  //     }
  //   }).pipe(pluck('data', 'job_applicants'));
  // }

  getAppliedData(
    dental_professional_id: string
  ): Observable<{ applicants: any[]; jobIds: string[] }> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAppliedDatas,
        variables: {
          dental_professional_id: dental_professional_id,
        },
      })
      .pipe(
        pluck('data', 'job_applicants'),
        map((applicants: any[]) => {
          const jobIds = applicants
            .map((app) => app.job_id)
            .filter((id: string | null) => !!id);
          return { applicants, jobIds };
        })
      );
  }

  getAppliedJobData(
    ids: string[],
    limit: number = 10,
    offset: number = 0
  ): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getApplicantsJobDatas,
        variables: {
          id: ids,
          limit,
          offset,
        },
      })
      .pipe(pluck('data', 'jobs'));
  }

  addApplicantMessage(message: any): Promise<any> {
    return this.apollo
      .mutate({
        mutation: addApplicantMessageMutation,
        variables: {
          object: message,
        },
      })
      .toPromise();
  }

  getAllapplicantMessage(jobId: any): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getApplicantMessagemutation,
        variables: {
          job_id: jobId,
        },
      })
      .pipe(pluck('data', 'job_applicant_messages'));
  }

  deleteApplicantMessage(messageId: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: deleteMessageMutation,
        variables: {
          id: messageId,
          deleted_status: true,
        },
      })
      .toPromise();
  }

  editApplicantMessages(id: string, message: string): Promise<any> {
    return this.apollo
      .mutate({
        mutation: editApplicantMessageMutations,
        variables: {
          id: id,
          message: message,
        },
      })
      .toPromise();
  }

  // enquiryListmessage
  getEnquiryList(dental_professional_id: any): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getEnquiryListMutation,
        variables: {
          dental_professional_id: dental_professional_id,
        },
      })
      .pipe(pluck('data', 'job_enquiries'));
  }
  getEnquiryListData(
    dental_professional_id: string
  ): Observable<{ enquiries: any[]; jobIds: string[] }> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getEnquiryListMutation,
        variables: {
          dental_professional_id: dental_professional_id,
        },
      })
      .pipe(
        pluck('data', 'job_enquiries'),
        map((enquiries: any[]) => {
          const jobIds = enquiries
            .map((enq) => enq.job_id)
            .filter((id: string | null) => !!id);
          return { enquiries, jobIds };
        })
      );
  }

  getAllEnquiry(id: string): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAllEnquiry,
        variables: {
          job_id: id,
        },
      })
      .pipe(pluck('data', 'job_enquiries'));
  }

  getAllEnquiryMessage(jobId: any): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getEnquiryMessagemutation,
        variables: {
          job_id: jobId,
        },
      })
      .pipe(pluck('data', 'job_applicant_messages'));
  }

  getFilteredJobProfiles(filters: {
    professions?: string[];
    types?: string[];
    experienceRanges?: string;
    salaryRanges?: any[];
    hiringPeriods?: any[];
    hiringDay?: any[];
    availabilityDates?: any;
  }): Observable<any[]> {
    const whereConditions: any[] = [{ status: { _eq: 'APPROVE' } }];
    if (filters.professions?.length) {
      whereConditions.push({ j_role: { _in: filters.professions } });
    }
    if (filters.types?.length) {
      whereConditions.push({
        TypeofEmployment: { _has_keys_any: filters.types },
      });
    }
    if (filters.experienceRanges) {
      whereConditions.push({
        years_of_experience: { _eq: filters.experienceRanges },
      });
    }
    if (filters.salaryRanges?.length) {
      whereConditions.push({ _or: filters.salaryRanges });
    }
    if (filters.hiringPeriods?.length) {
      if (filters.hiringPeriods.length === 1) {
        whereConditions.push(filters.hiringPeriods[0]);
      } else {
        whereConditions.push({ _or: filters.hiringPeriods });
      }
    }
    //  Add this block for hiringDay filter
    if (filters.hiringDay?.length) {
      if (filters.hiringDay.length === 1) {
        whereConditions.push(filters.hiringDay[0]);
      } else {
        whereConditions.push({ _or: filters.hiringDay });
      }
    }

    // availabilityDates
    if (filters.availabilityDates) {
      whereConditions.push(filters.availabilityDates);
    }

    const where = { _and: whereConditions };
    return this.apollo
      .query<any>({
        query: getAllJobsfiltered,
        variables: { where },
      })
      .pipe(map((result) => result.data.jobs));
  }

  async postHiring(jobHiringsDetails: any): Promise<any> {

    try {
      await this.apollo.mutate({
        mutation: talentPostservice,
        variables: { jobHiringsDetails }
      }).pipe(pluck('data', 'insert_jobpost')).toPromise();
      this.toast.openSnackBar(
        'Added successfully'
      );
      return true
    } catch (err) {
      this.toast.openSnackBar('You Failed To add');
      return false
    }

  }

  async updateHiringStatus(id: string): Promise<boolean> {
    try {
      await this.apollo.mutate({
        mutation: updateHiringStatusMutation,
        variables: { id, status: 'PENDING' }  // Force it to PENDING
      }).toPromise();

      this.toast.openSnackBar('Status updated successfully');
      return true;
    } catch (error) {
      console.error('Error updating hiring status:', error);
      this.toast.openSnackBar('Failed to update status');
      return false;
    }
  }




  getAllTalents(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAllTalentsHire,
      })
      .pipe(pluck('data', 'jobhirings'));
  }


  getAllTalentsRequest(
    professionalId: string,
    hiringStatus:string,
    limit: number,
    offset: number
  ): Observable<any[]> {
    const where = {
      dental_professional_id: { _eq: professionalId },
      hiring_status: { _eq: hiringStatus }
      // hiring_status: { _nin: ['REJECT', 'CANCELLED'] },
    };

    return this.apollo
      .use('external')
      .query({
        query: getAllTalentsRequest,
        fetchPolicy: 'network-only',
        variables: { where, limit, offset },
      })
      .pipe(pluck('data', 'jobhirings'));
  }

  getRequestCountOnly(professionalId: string): Observable<any> {

    const where = { dental_professional_id: { _eq: professionalId } };
    
    return this.apollo
      .use('external')
      .query({
        query: getRequestCountOnlyQuery,
         variables: { where },
         fetchPolicy: 'network-only'
      })
      .pipe(pluck('data'));
  }


  updateHireTalentApproveStatus(
    talentId: string,
    status: string
  ): Observable<any> {
    return this.apollo.mutate({
      mutation: updateTalentHireApproveStatusMutation,
      variables: {
        id: talentId,
        status: status,
      },
    });
  }

  getAllTalentMessage(jobId: any): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getTalentMessagemutation,
        variables: {
          job_id: jobId,
        },
      })
      .pipe(pluck('data', 'talents_message'));
  }

  getAllTalentEnquiryMessage(jobId: any): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getTalentEnquiryMessagemutation,
        variables: {
          job_id: jobId,
        },
      })
      .pipe(pluck('data', 'talents_message'));
  }

  addTalentMessage(message: any): Promise<any> {
    return this.apollo
      .mutate({
        mutation: addTalentMessageMutation,
        variables: {
          object: message,
        },
      })
      .toPromise();
  }

  deleteTalentMessage(messageId: any): Promise<any> {
    return this.apollo
      .mutate({
        mutation: deleteTalentMessageMutation,
        variables: {
          id: messageId,
          deleted_status: true,
        },
      })
      .toPromise();
  }

  editTalentMessages(
    id: string,
    message: string,
    updated_at: string
  ): Promise<any> {
    return this.apollo
      .mutate({
        mutation: editTalentMessageMutation,
        variables: {
          id: id,
          message: message,
          updated_at: updated_at,
        },
      })
      .toPromise();
  }

  // Talent enquiryList
  getTalentEnquiryList(login_id: any): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getTalentEnquiryListMutation,
        variables: {
          login_id: login_id,
        },
      })
      .pipe(pluck('data', 'talent_enquiries'));
  }

  getAllTalentRequest(id: any): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAllRequestMutation,
        variables: {
          job_id: id,
        },
      })
      .pipe(pluck('data', 'jobhirings'));
  }

  getAllTalentRequestList(id: any): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAllRequestMutation,
        variables: {
          job_id: id,
        },
      })
      .pipe(
        pluck('data', 'jobhirings'),
        map((jobhirings: any[]) => {
          const uniqueMap = new Map();

          for (const item of jobhirings) {
            if (!uniqueMap.has(item.dental_supplier_id)) {
              uniqueMap.set(item.dental_supplier_id, item);
            }
          }

          return Array.from(uniqueMap.values());
        })
      );
  }

  getAllTalentEnquiry(id: any): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAllTalentEnquiryMutation,
        variables: {
          job_id: id,
        },
      })
      .pipe(pluck('data', 'talent_enquiries'));
  }

  getAllTalentEnquirys(
    id: any,
    filterRequest: any[],
    limit = 10,
    offset = 0
  ): Observable<any[]> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAllTalentEnquiryMutation,
        variables: {
          job_id: id,
          limit: limit,
          offset: offset,
        },
      })
      .pipe(
        pluck('data', 'talent_enquiries'),
        map((enquiries: any[]) => {
          const uniqueEnquiries = enquiries.filter(
            (currentItem, currentIndex, array) =>
              array.findIndex(
                (item) => item.enquiry_from === currentItem.enquiry_from
              ) === currentIndex
          );

          const matchedHired = filterRequest.filter((hired) =>
            uniqueEnquiries.some(
              (enquiry) => enquiry.enquiry_from === hired.dental_supplier_id
            )
          );

          const remainingEnquiries = uniqueEnquiries.filter(
            (enquiry) =>
              !filterRequest.some(
                (hired) => enquiry.enquiry_from === hired.dental_supplier_id
              )
          );

          const combined = [...matchedHired, ...remainingEnquiries];

          // Since we now use Hasura's native limit/offset, no need to slice here
          return combined;
        })
      );
  }

  getEnquiryCountOnly(TalentId: string): Observable<number> {
    return this.apollo
      .use('external')
      .query({
        query: getEnquiryCountOnlyQuery,
        variables: { talent_id: TalentId },
        fetchPolicy: 'network-only',
      })
      .pipe(pluck('data', 'talent_enquiries_aggregate', 'aggregate', 'count'));
  }

  getAllTalentEnquiryPaginated(
    jobId: string,
    limit: number,
    offset: number,
    filterRequest: any[]
  ): Observable<any[]> {
    return this.apollo
      .use('external')
      .query({
        query: getAllTalentEnquiryPaginationQuery,
        variables: { job_id: jobId, limit, offset },
        fetchPolicy: 'network-only', // optional: avoids caching
      })
      .pipe(
        pluck('data', 'talent_enquiries'),
        map((enquiries: any[]) => {
          if (!enquiries || !filterRequest) return [];

          // Remove duplicate enquiries based on `enquiry_from`
          const uniqueEnquiries = enquiries.filter(
            (currentItem, index, array) =>
              array.findIndex(
                (item) => item.enquiry_from === currentItem.enquiry_from
              ) === index
          );

          // Match with hired suppliers (requests)
          const matchedHirings = filterRequest.filter((hired) =>
            uniqueEnquiries.some(
              (enquiry) => enquiry.enquiry_from === hired.dental_supplier_id
            )
          );

          const unmatchedEnquiries = uniqueEnquiries.filter(
            (enquiry) =>
              !filterRequest.some(
                (hired) => enquiry.enquiry_from === hired.dental_supplier_id
              )
          );

          return [...matchedHirings, ...unmatchedEnquiries];
        })
      );
  }

  getAllTalentEnquiryList(dental_professional_id: any): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAllTAlentEnquiryListMutation,
        variables: {
          dental_professional_id: dental_professional_id,
        },
      })
      .pipe(pluck('data', 'talent_enquiries'));
  }

  //  filter talent data
  // limit data 
  getFilterJobs(
    limit: number,
    offset: number,
    filters: any = {},
    sort: string = 'desc'
  ): Observable<any[]> {

    const today = new Date().toISOString().split('T')[0];
    const where: any = {
      _and: [
        { status: { _eq: 'APPROVE' } },
        { active_status: { _eq: 'ACTIVE' } },

        {
          _or:[
            {start_Date: {_lte : today}},
            {start_Date: {_is_null: true}}
          ]
        }
      ],
    };

    if (filters.searchText) {
      where._and.push({
        _or: [
          { title: { _ilike: `%${filters.searchText}%` } },
          { company_name: { _ilike: `%${filters.searchText}%` } },
          { location: { _ilike: `%${filters.searchText}%` } },
          { city: { _ilike: `%${filters.searchText}%` } },
          { state: { _ilike: `%${filters.searchText}%` } },
        ],
      });
    }

    // Similar jobs filter
    if (filters.j_role) {
      where._and.push({ j_role: { _eq: filters.j_role } });
    }
    // if (filters.excludeId) {
    //   where._and.push({ id: { _neq: filters.excludeId } });
    // }

      if (filters.availability_date?.length) {
        // Use _has_keys_any so it matches if any selected date exists in DB
        where._and.push({
          availability_date: { _has_keys_any: filters.availability_date },
        });
      }



    if (filters.professions?.length) {
      where._and.push({ j_role: { _in: filters.professions } });
    }
    if (filters.types?.length) {
      where._and.push({ TypeofEmployment: { _contains: filters.types } });
    }
    if (filters.states?.length) {
      where._and.push({ state: { _in: filters.states } });
    }

    if (filters.experienceRanges) {
      where._and.push({ years_of_experience: { _eq: filters.experienceRanges } });
    }

    let order_by: any[] = [];
    if (sort === 'atoz') {
      order_by.push({ title: 'asc' }); // use 'title'
    } else if (sort === 'ztoa') {
      order_by.push({ title: 'desc' }); // use 'title'
    } else {
      order_by.push({ created_at: 'desc' });
    }



    return this.apollo.use("external").query({
      query: getJobListMutation,
      variables: { limit, offset, where, order_by }
    }).pipe(pluck('data', 'jobs'));
  }

  // jobs new

  getFilteredJobs(
    limit: number,
    offset: number,
    selectedStatus?: string,
    empType?: string,
    company?: string,
    role?: string,
    status?: string
  ): Observable<any> {
    const loginData = this.loginService.getLoginData();
    const selected = selectedStatus?.toUpperCase();
    let where: any = {};

    if (loginData?.type === 'ADMIN') {
      // Basic status filter
      if (selected === 'ALL') {
        where.status = { _in: ['PENDING', 'APPROVE', 'REJECT', 'EXPIRED'] };
      } else if (selected) {
        where.status = { _eq: selected };
      }

      // Filters
      if (company && company.trim() !== '') {
        where.company_name = { _ilike: `%${company}%` };
      }

      if (role && role.trim() !== '') {
        where.j_role = { _ilike: `%${role}%` };
      }

      if (status && status.trim() !== '') {
        where.status = { _eq: status };
      }

      if (empType && empType.trim() !== '') {
        where.TypeofEmployment = { _contains: empType };
      }
    }

    if (loginData?.type === 'SUPPLIER') {
      where.dental_supplier_id = { _eq: loginData.id };

      if (selected === 'ACTIVE' || selected === 'INACTIVE') {
        where.status = { _eq: 'APPROVE' };
        where.active_status = { _eq: selected };
      } else if (selected && selected !== 'ALL') {
        where.status = { _eq: selected };
      }
    }

    if (loginData?.type === 'PRACTICE') {
      where.dental_practice_id = { _eq: loginData.id };

      if (selected === 'ACTIVE' || selected === 'INACTIVE') {
        where.status = { _eq: 'APPROVE' };
        where.active_status = { _eq: selected };
      } else if (selected && selected !== 'ALL') {
        where.status = { _eq: selected };
      }
    }

    return this.apollo
      .use('external')
      .subscribe({
        query: getFilteredJobs,
        variables: {
          limit,
          offset,
          where,
        },
      })
      .pipe(pluck('data', 'jobs'));
  }

  getJobsFilterDropdown(where?: any): Observable<any> {
    return this.apollo
      .query({
        query: gql`
          query getJobFilter($where: jobs_bool_exp) {
            status: jobs(distinct_on: status, where: $where) {
              status
            }
            allJobs: jobs(where: $where) {
              TypeofEmployment
            }
          }
        `,
        variables: { where },
      })
      .pipe(pluck('data'));
  }

  // jobs

  getJobsTabCounts(): Observable<any> {
    const loginData = this.loginService.getLoginData();
    const userType = loginData?.type;
    const userId = loginData?.id;

    if (userType === 'ADMIN') {
      const where = {
        status: { _in: ['PENDING', 'APPROVE', 'REJECT', 'EXPIRED'] },
      };
      return this.apollo.use('external').subscribe({
        query: getAdminJobsTabCounts,
        variables: { where },
      });
    }

    if (userType === 'SUPPLIER' || userType === 'PRACTICE') {
      const loginId =
        userType === 'SUPPLIER' ? 'dental_supplier_id' : 'dental_practice_id';
      const where = { [loginId]: { _eq: userId } };

      return this.apollo.use('external').subscribe({
        query: getUserJobsTabCounts,
        variables: { where },
      });
    }

    return EMPTY;
  }
  // jobs end


  // my talent new
  // my talent new
  getFilterTalent(
    limit: number,
    offset: number,
    admin_status?: string,
    active_status?: string,
    role?: string,
    status?: string,
    empType?: string,

  ): Observable<any> {
    const loginData = this.loginService.getLoginData();

    let where: any = {};

    const isAdmin = loginData?.type === 'ADMIN';
    if (isAdmin) {
      const andConditions: any[] = [];

      andConditions.push({ admin_status: { _neq: 'DRAFT' } });

      if (active_status) {
        andConditions.push({ active_status: { _eq: active_status } });
      }

      if (admin_status) {
        andConditions.push({ admin_status: { _eq: admin_status } });
      }


      if (role && role.trim() !== '') {
        andConditions.push({ profession_type: { _ilike: `%${role}%` } });
      }

      if (status && status.trim() !== '') {
        andConditions.push({ admin_status: { _eq: status } });
      }

      if (empType && empType.trim() !== '') {
        andConditions.push({ work_type: { _contains: empType } });
      }

      // Combine conditions
      where = { _and: andConditions };
    }


    return this.apollo.use('external').subscribe({
      query: getFilteredTalentList,
      variables: {
        where,
        limit,
        offset
      },
    });
  }

  // talent list count admin

  getTalentAdminTabCounts(): Observable<any> {
    const loginData = this.loginService.getLoginData();
    const isAdmin = loginData?.type === 'ADMIN';

    const whereAll = {
      _or: [
        { admin_status: { _neq: 'DRAFT' } }
      ],
    };


    return this.apollo.subscribe({
      query: getTalentAdminCountByStatus,
      variables: {
        whereAll,
      },
    });
  }

  //  aprove talent admin

  updateTalentStatus(courseId: string, status: string): Observable<any> {
    return this.apollo.mutate({
      mutation: updateTalentStatusMutation,
      variables: {
        id: courseId,
        admin_status: status,
      },
    });
  }

  // talent filter admin

  getUniqueFilterOptions(where?: any): Observable<{
    admin_status: string[];
    profession_types: string[];
  }> {
    return this.apollo
      .query({
        query: getUniqueTalentFilterOptions,
        variables: { where },
      })
      .pipe(
        map((result: any) => {
          const data = result?.data;
          return {
            admin_status: data.admin_status
              .map((item: any) => item.admin_status)
              .filter(Boolean),
            profession_types: data.profession_types
              .map((item: any) => item.profession_type)
              .filter(Boolean),
          };
        })
      );
  }

  // Supplier and Practice hiring status Filter

  getFilterHiringTalent(
    limit: number,
    offset: number,
    hiring_status?: string,
    role?: string,
    hiring_status_user?: string,
    empType?: string
  ): Observable<any> {
    const loginData = this.loginService.getLoginData();

    let where: any = {};

    const andConditions: any[] = [];

    if (loginData?.type === 'SUPPLIER') {
      andConditions.push({ dental_supplier_id: { _eq: loginData.id } });
    }

    if (loginData?.type === 'PRACTICE') {
      andConditions.push({ dental_practice_id: { _eq: loginData.id } });
    }

    if (hiring_status) {
      andConditions.push({ hiring_status: { _eq: hiring_status } });
    }

    if (hiring_status_user && hiring_status_user.trim() !== '') {
      andConditions.push({ hiring_status: { _eq: hiring_status_user } });
    }

    if (role && role.trim() !== '') {
      andConditions.push({
        job_profiles: { profession_type: { _ilike: `%${role}%` } },
      });
    }

    if (empType && empType.trim() !== '') {
      andConditions.push({
        job_profiles: { work_type: { _contains: empType } },
      });
    }

    // Combine conditions
    where = { _and: andConditions };

    return this.apollo.subscribe({
      query: getHiringTalentList,
      variables: { where, limit, offset },
    });
  }


  // hiring talent user count

  getHiringTalentTabCounts(): Observable<any> {
    const loginData = this.loginService.getLoginData();
    const userType = loginData?.type;
    const userId = loginData?.id;

    if (userType === 'SUPPLIER' || userType === 'PRACTICE') {
      const loginId = userType === 'SUPPLIER' ? 'dental_supplier_id' : 'dental_practice_id';
      const where = { [loginId]: { _eq: userId } };

      return this.apollo.use('external').subscribe({
        query: getHiringTalentCountByStatus,
        variables: { where }
      });
    }

    return EMPTY;
  }

  // talent filter supplier

  getHiringFilterOptions(whereProfiles?: any): Observable<{
    hiring_status: string[];
    profession_types: string[];
  }> {
    return this.apollo
      .query({
        query: getHiringFilterOptions,
        variables: { whereProfiles },
      })
      .pipe(
        map((result: any) => {
          const data = result?.data;
          return {
            hiring_status: data.hiring_status
              .map((item: any) => item.hiring_status)
              .filter(Boolean),
            profession_types: data.profession_types
              .map((item: any) => item.profession_type)
              .filter(Boolean),
          };
        })
      );
  }

  getCompanyName(
    limit: number,
    offset: number,
    search: string = ''
  ): Observable<any> {
    const searchValue = search ? `%${search}%` : '%%'; // ilike needs wildcard
    return this.apollo
      .use('external')
      .query({
        query: getJobCompanyName,
        variables: { limit, offset, search: searchValue },
      })
      .pipe(pluck('data', 'jobs'));
  }

  getRoleName(
    limit: number,
    offset: number,
    search: string = ''
  ): Observable<any> {
    const searchValue = search ? `%${search}%` : '%%'; // ilike needs wildcard
    return this.apollo
      .use('external')
      .query({
        query: getJobRoleName,
        variables: { limit, offset, search: searchValue },
      })
      .pipe(pluck('data', 'jobs'));
  }

  // filter status option
  getFilterStatus(
    limit: number,
    offset: number,
    search: string = ''
  ): Observable<any> {
    const searchValue = search ? `%${search}%` : '%%'; // ilike needs wildcard
    return this.apollo
      .use('external')
      .query({
        query: getFilterStatus,
        variables: { limit, offset, search: searchValue },
      })
      .pipe(pluck('data', 'jobs'));
  }

  getEmployeeTypes(
    limit: number,
    offset: number,
    search: string = ''
  ): Observable<string[]> {
    return this.apollo
      .use('external')
      .query({
        query: getEmpTypeName,
        variables: { limit, offset }, // no search variable
      })
      .pipe(
        pluck('data', 'jobs'),
        map((res: any[]) => {
          // Flatten arrays from all rows
          const flattened: string[] = res
            .map((r) => r.TypeofEmployment)
            .reduce((acc, val) => acc.concat(val), [])
            .filter(Boolean);

          // Remove duplicates
          const uniqueTypes = Array.from(new Set(flattened));

          // Apply frontend search
          const searchValue = search.trim().toLowerCase();
          if (searchValue) {
            return uniqueTypes.filter((emp) =>
              emp.toLowerCase().includes(searchValue)
            );
          }
          return uniqueTypes;
        })
      );
  }


  // JOb applicants:

  getMyJobData(jobId: string): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getMyJobData,
        variables: { jobId },
      })
      .pipe(pluck('data', 'jobs_by_pk'));
  }

  // new applicant query implemented:

  getFilteredApplicants(
    limit: number,
    offset: number,
    selectedStatus?: string,
    JobId?: string
  ): Observable<any> {
    const loginData = this.loginService.getLoginData();
    const selected = selectedStatus?.toUpperCase();


    let where: any = {};
    if (JobId) {
      where.job_id = { _eq: JobId };
    }

    if (selected === 'ENQUIRY') {
      // Different query for talent_enquiries
      return this.apollo
        .use('external')
        .subscribe({
          query: getJobFilteredEnquiry,
          variables: { where, limit, offset },
        })
        .pipe(pluck('data', 'job_enquiries'));
    }

    // Basic status filter
    if (selected === 'ALL') {
      where.status = {
        _in: ['APPLIED', 'SHORTLISTED', 'ACCEPTED', 'INTERVIEWS', 'DECLINED'],
      };
    } else if (selected) {
      where.status = { _eq: selected };
    }

    return this.apollo
      .use('external')
      .subscribe({
        query: getFilteredApplicants,
        variables: {
          limit,
          offset,
          where,
        },
      })
      .pipe(pluck('data', 'job_applicants'));
  }

  // new job Applicant message:
  getApplicantMessage(ApplicantId: string, EnquiryId: string): Observable<any> {
    let orConditions = [];
    if (ApplicantId)
      orConditions.push({ job_applicant_id: { _eq: ApplicantId } });
    if (EnquiryId) orConditions.push({ job_enquiry_id: { _eq: EnquiryId } });

    let where: any = { _or: orConditions.length ? orConditions : undefined };

    return this.apollo
      .use('external')
      .subscribe({
        query: getApplicantsMessage,
        variables: { where },
      })
      .pipe(pluck('data', 'job_applicant_messages'));
  }

  // test limit
  TestgetApplicantMessage(
    ApplicantId: string,
    EnquiryId: string,
    limit: number,
    offset: number
  ): Observable<any> {

    let orConditions = [];
    if (ApplicantId)
      orConditions.push({ job_applicant_id: { _eq: ApplicantId } });
    if (EnquiryId) orConditions.push({ job_enquiry_id: { _eq: EnquiryId } });

    let where: any = { _or: orConditions.length ? orConditions : undefined };

    return this.apollo
      .use('external')
      .subscribe({
        query: TestgetApplicantsMessage,
        variables: { where, limit, offset },
      })
      .pipe(pluck('data', 'job_applicant_messages'));
  }

  // new job applicant enquiry

  getApplicantEnquiry(jobID: string, userID: string): Observable<any> {
    let where = {
      job_id: { _eq: jobID },
      enquiry_userid: { _eq: userID },
    };
    return this.apollo
      .use('external')
      .subscribe({
        query: getApplicantsEnquiry,
        variables: { where },
      })
      .pipe(pluck('data', 'job_enquiries'));
  }

  // new job applicant tab count

  getapplicantTabCounts(jobIdInfo: string): Observable<any> {
    const where = { job_id: { _eq: jobIdInfo } };

    return this.apollo.use('external').subscribe({
      query: getApplicantTabcount,
      variables: { where },
    });
  }

  // new my applied job data

  getMyAppliedJobs(limit: number, offset: number): Observable<any> {
    const loginData = this.loginService.getLoginData();

    let where: any = { dental_professional_id: { _eq: loginData?.id } };

    return this.apollo
      .use('external')
      .subscribe({
        query: getMyappliedJobData,
        variables: {
          limit,
          offset,
          where,
        },
      })
      .pipe(pluck('data', 'job_applicants'));
  }

  // my enquiry jobs

  getMyEnquiryJobs(limit: number, offset: number): Observable<any> {
    const loginData = this.loginService.getLoginData();

    let where: any = { enquiry_userid: { _eq: loginData?.id } };

    return this.apollo
      .use('external')
      .subscribe({
        query: getMyEnquiryJobData,
        variables: {
          limit,
          offset,
          where,
        },
      })
      .pipe(pluck('data', 'job_enquiries'));
  }

  // my enquiry talent

  getMyEnquiryTalent(limit: number, offset: number): Observable<any> {
    const loginData = this.loginService.getLoginData();

    let where: any = { enquiry_from: { _eq: loginData?.id } };

    return this.apollo
      .use('external')
      .subscribe({
        query: getMyEnquiryTalentData,
        variables: {
          limit,
          offset,
          where,
        },
      })
      .pipe(pluck('data', 'talent_enquiries'));
  }

  // new Talent  message:
  getTalentMessage(ApplicantId: string, EnquiryId: string): Observable<any> {
    let orConditions = [];
    if (ApplicantId)
      orConditions.push({ talent_message_id_to: { _eq: ApplicantId } });
    if (EnquiryId)
      orConditions.push({ enquiry_message_id_to: { _eq: EnquiryId } });

    let where: any = { _or: orConditions.length ? orConditions : undefined };

    return this.apollo
      .use('external')
      .subscribe({
        query: getTalentsMessage,
        variables: { where },
      })
      .pipe(pluck('data', 'talents_message'));
  }

  // Get Talent enquiry
  getTalentEnquiry(talentID: string, userID: string): Observable<any> {
    let where = {
      talent_id: { _eq: talentID },
      enquiry_from: { _eq: userID },
    };
    return this.apollo
      .use('external')
      .subscribe({
        query: getTalentsEnquiry,
        variables: { where },
      })
      .pipe(pluck('data', 'talent_enquiries'));
  }

  // Get profession received enquiry

  getAllTalentEnquiryData(
    limit: number,
    offset: number,
    talentID: string
  ): Observable<any> {
    let where: any = { talent_id: { _eq: talentID } };

    return this.apollo
      .use('external')
      .subscribe({
        query: getAllEnquiryTalentData,
        variables: {
          limit,
          offset,
          where,
        },
      })
      .pipe(pluck('data', 'talent_enquiries'));
  }

  // editJobPost(Jobid: string): Observable<any[]> {
  //   return this.apollo
  //     .use('external')
  //     .query({
  //       query: GetEditJobID,
  //       variables: { Jobid },
  //     })
  //     .pipe(pluck('data', 'jobs'));
  // }



}